import "~/scripts/global/shopify_common.js";
import "~/scripts/global/config.js";
import "~/scripts/global/utils.js";
import "~/scripts/global/focusable-widget.js";
import { Accordion } from "~/scripts/components/accordion";
import { ActiveFilters } from "~/scripts/components/active-filters";
import { BundleAndSave } from "~/scripts/components/bundle-and-save";
import { Carousel } from "~/scripts/components/carousel";
import { CarouselHero } from "~/scripts/components/carousel--hero";
import { CarouselHeroAbout } from "~/scripts/components/carousel--hero-about";
import {
    CartDrawer,
    CartDrawerItems,
    CartItems,
    CartNote,
    CartRemoveButton,
    CartUpsell,
} from "~/scripts/components/cart";
import { CartSamples } from "~/scripts/components/cart-samples";
import { Countdown } from "~/scripts/components/countdown";
import { Drawer } from "~/scripts/components/drawers";
import { FilterSort } from "~/scripts/components/filter-sort";
import { SiteHeader } from "~/scripts/components/header";
import { LoadingSpinner } from "~/scripts/components/loading-spinner";
import { LocalizationForm } from "~/scripts/components/localization-form";
import { Modal } from "~/scripts/components/modals";
import { PredictiveSearch } from "~/scripts/components/predictive-search";
import { PriceRange } from "~/scripts/components/price-range";
import { ProductOptions } from "~/scripts/components/product-options";
import { QuantityInput } from "~/scripts/components/quantity-input";
import { RecentlyViewed } from "~/scripts/components/recently-viewed";
import { RelatedProducts } from "~/scripts/components/related-products";
import { Select } from "~/scripts/components/select";
import { Tabs } from "~/scripts/components/tabs";
import { VideoOverlay } from "~/scripts/components/video-overlay";
import { CollectionGrid } from "~/scripts/sections/collection__grid";
import { ProductMain } from "~/scripts/sections/product__main";
import { ProductRecommendations } from "~/scripts/sections/product__recommendations";
import { Account } from "~/scripts/templates/account";
import { Register } from "~/scripts/templates/register";

window.theme = window.theme || {};

customElements.define("s-drawer", Drawer);
customElements.define("s-modal", Modal);
customElements.define("s-accordion", Accordion);
customElements.define("s-tabs", Tabs);
customElements.define("s-carousel", Carousel);
customElements.define("carousel-hero", CarouselHero);
customElements.define("hero-about", CarouselHeroAbout);

customElements.define("cart-remove-button", CartRemoveButton);
customElements.define("cart-items", CartItems);
customElements.define("cart-note", CartNote);
customElements.define("cart-drawer", CartDrawer);
customElements.define("cart-drawer-items", CartDrawerItems);
customElements.define("cart-upsell", CartUpsell);
customElements.define("cart-samples", CartSamples);

customElements.define("s-header", SiteHeader);

customElements.define("product-options", ProductOptions);
customElements.define("quantity-input", QuantityInput);
customElements.define("loading-spinner", LoadingSpinner);
customElements.define("predictive-search", PredictiveSearch);
customElements.define("filter-sort", FilterSort);
customElements.define("active-filters", ActiveFilters);
customElements.define("price-range", PriceRange);
customElements.define("s-select", Select);
customElements.define("related-products", RelatedProducts);
customElements.define("video-overlay", VideoOverlay);
customElements.define("recently-viewed", RecentlyViewed);
customElements.define("localization-form", LocalizationForm);
customElements.define("bundle-and-save", BundleAndSave);
customElements.define("s-countdown", Countdown);

customElements.define("s-collection-grid", CollectionGrid);

customElements.define("s-product", ProductMain);
customElements.define("product-recommendations", ProductRecommendations);

customElements.define("s-account", Account);
customElements.define("s-register", Register);
